import { Button } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { Navigate } from 'react-router-dom';

import { date as commonDate } from '@finley-technologies/common';

import { useCreateInvoiceContext } from '../../hooks/useCreateInvoice';
import { Icon } from 'packages/common-frontend/components/icons';
import { useGetLatestInvoiceFacilityFeeAccrualEndDateQuery } from 'packages/invoices/requests/invoices.gql.generated';
import { ErrorBoundary } from '~/contexts/MonitoringProvider';

const CreateInvoiceAddFacilityFeeComponentButtonBody = () => {
  const { invoice, addInvoiceComponent } = useCreateInvoiceContext();

  const {
    data: latestAccrualEndDate,
    loading: isLatestAccrualEndDateLoading,
    error: latestAccrualEndDateError,
  } = useGetLatestInvoiceFacilityFeeAccrualEndDateQuery({
    variables: {
      creditFacilityId: invoice.creditFacilityId,
    },
  });

  const onClickAddFacilityFee = useCallback(() => {
    if (latestAccrualEndDate?.getLatestInvoiceFacilityFeeAccrualEndDate) {
      const newAccrualEndDate = commonDate.addMonths(
        latestAccrualEndDate.getLatestInvoiceFacilityFeeAccrualEndDate,
        1,
      );

      addInvoiceComponent({
        invoiceComponentType: 'creditFacility',
        totalAmount: 0,
        accrualStartDate:
          latestAccrualEndDate.getLatestInvoiceFacilityFeeAccrualEndDate,
        accrualEndDate: newAccrualEndDate,
      });
    } else {
      const endDate = invoice.dueDate ?? commonDate.currentDateStr();
      addInvoiceComponent({
        invoiceComponentType: 'creditFacility',
        totalAmount: 0,
        accrualStartDate: commonDate.addMonths(endDate, -1), // @dani todo: update this default based on product response
        accrualEndDate: endDate,
      });
    }
  }, [addInvoiceComponent, latestAccrualEndDate, invoice]);

  if (latestAccrualEndDateError) {
    throw latestAccrualEndDateError;
  }

  return (
    <Button
      variant="secondary"
      colorScheme="v2-aurora"
      onClick={onClickAddFacilityFee}
      leftIcon={<Icon icon="plus" />}
      w="fit-content"
      isLoading={isLatestAccrualEndDateLoading || !latestAccrualEndDate}
    >
      Add Facility Fee
    </Button>
  );
};

export const CreateInvoiceAddFacilityFeeComponentButton = () => {
  return (
    <ErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/invoices" />;
      }}
    >
      <CreateInvoiceAddFacilityFeeComponentButtonBody />
    </ErrorBoundary>
  );
};
